import { languages } from '@/i18n/settings';

/**
 * Get language code from pathname
 */
export function getLngFromPath(pathname: string): string {
  const match = pathname.match(/^\/([a-z]{2})\//);
  return match ? match[1] : 'en';
}

/**
 * Replace language in URL path
 */
export function replaceLanguageInPath(pathname: string, newLng: string): string {
  const currentLng = getLngFromPath(pathname);
  if (!currentLng) return `/${newLng}${pathname}`;
  return pathname.replace(`/${currentLng}`, `/${newLng}`);
}

/**
 * Validate if language code is supported
 */
export function isValidLanguage(lng: string): boolean {
  return languages.includes(lng);
}

/**
 * Format date according to language
 */
export function formatDateByLanguage(date: Date, lng: string): string {
  const locales: Record<string, string> = {
    en: 'en-US',
    es: 'es-ES',
    it: 'it-IT',
    fr: 'fr-FR',
    zh: 'zh-CN',
    pt: 'pt-PT'
  };

  return new Intl.DateTimeFormat(locales[lng] || 'en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  }).format(date);
}

/**
 * Format number according to language
 */
export function formatNumberByLanguage(num: number, lng: string): string {
  const locales: Record<string, string> = {
    en: 'en-US',
    es: 'es-ES',
    it: 'it-IT',
    fr: 'fr-FR',
    zh: 'zh-CN',
    pt: 'pt-PT'
  };

  return new Intl.NumberFormat(locales[lng] || 'en-US').format(num);
}

/**
 * Format credits according to language
 */
export function formatCreditsByLanguage(amount: number, lng: string): string {
  const locales: Record<string, string> = {
    en: 'en-US',
    es: 'es-ES',
    it: 'it-IT',
    fr: 'fr-FR',
    zh: 'zh-CN',
    pt: 'pt-PT'
  };

  return `${new Intl.NumberFormat(locales[lng] || 'en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)} credits`;
}
